import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicGestureConfig } from './utils/gesture.config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationHelper } from './helpers/navigation';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { EnvironmentService } from './services/environment.service';
import { NoteService } from './services/note.service';
import { UserStateService } from './services/user-state.service';
import { LocalStorageHelper } from './helpers/local-storage';
import { HttpHelper } from './helpers/http';
import { PottyNotesAlertController } from './error-handling/alerting/potty-notes-alert-controller';
import { LoaderService } from './services/loader-service';
import { NavigationEventService } from './services/navigation-event.service';
import { HistoryTrackerService } from './services/history-tracker.service';
import { ForgotPasswordService } from './services/forgot-password.service';

@NgModule({ declarations: [AppComponent],
    bootstrap: [
        AppComponent
    ], imports: [BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        BrowserAnimationsModule,
        HammerModule], providers: [{
            provide: RouteReuseStrategy, useClass: IonicRouteStrategy
        },
        NoteService,
        UserStateService,
        EnvironmentService,
        NavigationHelper,
        LocalStorageHelper,
        PottyNotesAlertController,
        HttpHelper,
        LoaderService,
        NavigationEventService,
        HistoryTrackerService,
        ForgotPasswordService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
